export const SERVITUT_ANALYSIS_CONCURRENCY = 10;
export const SERVITUT_NOTE_SAVE_CONCURRENCY = 8;
export const SERVITUT_PDF_SAVE_CONCURRENCY = 5;
export const SERVITUT_CONTENT_CONCURRENCY = 3;

export function isAbortError(error: unknown): boolean {
   return error instanceof DOMException && error.name === "AbortError";
}

export function createAbortError(): DOMException {
   return new DOMException("Aborted", "AbortError");
}

export async function runWithConcurrency<T>(
   items: T[],
   concurrency: number,
   worker: (item: T) => Promise<void>,
   signal?: AbortSignal,
): Promise<void> {
   let nextIndex = 0;
   const workerCount = Math.min(concurrency, items.length);
   const runners = Array.from({ length: workerCount }, async () => {
      while (nextIndex < items.length && !signal?.aborted) {
         const item = items[nextIndex];
         nextIndex += 1;
         await worker(item);
      }
   });
   await Promise.all(runners);
}

export function groupBy<T>(items: T[], keyOf: (item: T) => string): T[][] {
   const groups = new Map<string, T[]>();
   items.forEach((item) => {
      const key = keyOf(item);
      const batch = groups.get(key) ?? [];
      batch.push(item);
      groups.set(key, batch);
   });
   return Array.from(groups.values());
}
